module.exports = __webpack_public_path__ + "static/virego_entire_page-0f654266a5a01db40153d6b83542641a.jpg";